 
enum RequestTan {
    None = 'none',
    SMS = 'smsTan',
    TAN= 'tan',
  }

export default RequestTan;